import "./Home.module.css";
import FraternalExcellenceHeader from "@/reusable_sections/Header";
import LEssenzaDelGusto from "./sections/LEssenzaDelGusto";
import AnalisiComparativaDeiCosti from "./sections/AnalisiComparativaDeiCosti";
import CostCalculator from "./sections/CostCalculator";
import OurCoreValues from "./sections/OurCoreValues";
import FromPrepToPublish from "./sections/FromPrepToPublish";
import ClinicaRaccomandataSkyDentalTirana from "./sections/ClinicaRaccomandataSkyDentalTirana";
import PatientGuides from "./sections/PatientGuides";
import DomandeFrequentiETestimonianze from "./sections/DomandeFrequentiETestimonianze";
import RichiediUnaConsulenzaGratuita from "./sections/RichiediUnaConsulenzaGratuita";
import Footer from "@/reusable_sections/Footer";
export default function HomePage() {
  return <div>
      <FraternalExcellenceHeader />
      <LEssenzaDelGusto />
      <AnalisiComparativaDeiCosti />
      <CostCalculator />
      <OurCoreValues />
      <FromPrepToPublish />
      <ClinicaRaccomandataSkyDentalTirana />
      <PatientGuides />
      <DomandeFrequentiETestimonianze />
      <RichiediUnaConsulenzaGratuita />
      <Footer />
    </div>;
}